import React, { useEffect, useState } from 'react'
import { Modal, Tooltip, Row } from 'antd'
import { Button, ColumnProps, FormContext, FormDatePicker, FormSubmitButton, MasterDetailForm, Table } from '@digital/ui'
import * as Yup from 'yup';
import { GetFileExtension, imageFormats } from '@app/helpers'
import { Visibility, SimpleUpload } from '@app/components'

import { isObjEmpty, isObjNotEmpty } from '@app/helpers/objHelper'

import { IArquivo } from '@app/types/core.types'
import './custom.css'


interface IArquivoActions {
    onUpload?: (values: any) => Promise<boolean>;
    onDownload?: (arquivo: IArquivo) => void;
    onView?: (arquivo: IArquivo) => void;
    onDelete?: (arquivo: IArquivo) => Promise<boolean>;
}

interface IFormValues {
    justificativa?: string;
    arquivo?: any;
    date: string;
}

interface Props {
    visible?: boolean;
    tooltip: string;
    buttonModalText?: string;
    title: string;

    buttonIcon?: string;
    buttonUploadText?: string;
    hasUpload?: boolean;
    onUpload?: (values: IFormValues) => Promise<boolean>;
    buttonUploadInFooter?: boolean;
    showUploadList?: boolean;

    hasJustification?: boolean;
    labelJustification?: string;
    placeholderJustification?: string;
    hasDatePicker?: boolean;
    labelDatePicker?: string;
    initialDate?: Date;

    onSubmit?: (values: IFormValues) => Promise<boolean>;
    onGetArquivos?: () => Promise<IArquivo[]>;

    arquivoActions?: IArquivoActions;

    onDownload?: () => void;
    onDownloadAllArquivos?: () => void;

    buttonModalFooterText?: string;
    validateOnUpload?: boolean;
}

export const UploadModalHistorico = ({
    tooltip,
    buttonModalText,
    title,
    buttonIcon,
    buttonUploadText = 'Adicionar Arquivo',
    hasUpload = false,
    onSubmit,
    onUpload,
    buttonUploadInFooter = false,
    hasJustification = false,
    labelJustification = 'Justificativa',
    placeholderJustification = 'Justificativa',
    hasDatePicker = false,
    labelDatePicker = 'Data',
    visible = true,
    onGetArquivos,
    arquivoActions,
    onDownloadAllArquivos,
    showUploadList = false,
    validateOnUpload = false,
    buttonModalFooterText = 'Salvar',
}: Props) => {
    // console.log('UploadModalHistorico', hasJustification, labelJustification, placeholderJustification);
    const [exibirModal, setExibirModal] = useState(false);

    const [arquivos, setArquivos] = useState<IArquivo[]>([]);

    const [tmpFileUpload, setTmpFileUpload] = useState<any>(null);

    const loadArquivos = async () => {
        onGetArquivos && onGetArquivos().then((arquivos) => {
            setArquivos(arquivos);
        });
    }

    useEffect(() => {
        if (exibirModal) {
            setArquivos([]);
            setTmpFileUpload(null);

            loadArquivos();
        }
    }, [exibirModal]);

    const renderTableActions = (record: IArquivo) => (
        <Row type='flex'>

            <SimpleUpload
                visible={isObjNotEmpty(arquivoActions)}
                idDoComponente="uploadSolicitacaoEnvioEsclarecimentosTecnicos"
                title={`${(isObjEmpty(record)) ? "Adicionar" : "Substituir"} Arquivo`}
                hasLabel={false}
                showUploadList={false}
                nameFormData='arquivo'
                onUploadVisible={arquivoActions && isObjNotEmpty(arquivoActions.onUpload)}
                onUpload={async (values) => arquivoActions
                    && arquivoActions.onUpload
                    && arquivoActions.onUpload({ ...record, ...values })
                        .then(() => loadArquivos())}
                onDownloadVisible={arquivoActions && isObjNotEmpty(arquivoActions.onDownload)}
                onDownload={() => arquivoActions
                    && arquivoActions.onDownload
                    && arquivoActions.onDownload(record)}
            />

            <Visibility
                visible={
                    arquivoActions && isObjNotEmpty(arquivoActions.onView)
                    && (GetFileExtension(record.nome) === "pdf" || imageFormats.includes(GetFileExtension(record.nome)))
                }
            >
                <Tooltip title="Visualizar Arquivo">
                    <Button
                        icon="files-view_file"
                        type="link"
                        onClick={() => arquivoActions && arquivoActions.onView && arquivoActions.onView(record)}
                    />
                </Tooltip>
            </Visibility>

            <Visibility
                visible={
                    arquivoActions && isObjNotEmpty(arquivoActions.onDelete)
                }
            >
                <Tooltip title="Delete Arquivo">
                    <Button
                        icon="commons-trash"
                        type="link"
                        onClick={async () => {
                            if (arquivoActions && arquivoActions.onDelete) {
                                arquivoActions.onDelete(record).then(data => {
                                    loadArquivos()
                                })
                            }
                        }}
                    />
                </Tooltip>
            </Visibility>
        </Row>
    );

    const columns = () => {
        let columns: ColumnProps<IArquivo>[] = [];

        columns.push({
            title: 'Arquivo',
            dataIndex: 'nome',
            // width: '40%'
        })

        columns.push({
            title: 'Status',
            className: "td-centralizado",
            dataIndex: 'status',
            width: '15%'
        })

        columns.push({
            title: 'Versão',
            className: "td-centralizado",
            dataIndex: 'versao',
            width: '10%'
        })

        columns.push({
            title: 'Ações',
            dataIndex: '',
            width: '15%',
            render(text, record, index) {
                return renderTableActions(record);
            },
        })


        return columns;
    }

    const onSubmitMasterDetailForm = (values: any) => {
        onSubmit && onSubmit(values)
            .then((data: boolean) => {
                if (data) {
                    setExibirModal(false);
                }
            });
        // if (isObjNotEmpty(showUploadList) && showUploadList == true) {
        //     values = { ...values, ...tmpFileUpload };
        //     onSubmit && onSubmit(values)
        //         .then((data: boolean) => {
        //             if (data) {
        //                 setExibirModal(false);
        //             }
        //         });
        // } else {
        //     onSubmit && onSubmit(values)
        //         .then((data: boolean) => {
        //             if (data) {
        //                 setExibirModal(false);
        //             }
        //         });
        // }
    }

    return (
        <Visibility
            visible={visible}
        >
            <Tooltip title={tooltip}>
                <Button
                    onClick={() => {
                        setExibirModal(true)
                    }}
                    icon={buttonIcon || "messaging-attach"}
                >
                    {buttonModalText}
                </Button>
            </Tooltip>
            <Visibility
                visible={exibirModal}
            >

                <Modal
                    title={title}
                    width="680px"
                    visible={exibirModal}
                    onCancel={() => setExibirModal(false)}
                    footer={null}
                >
                    <MasterDetailForm
                        onSubmit={onSubmitMasterDetailForm}
                        validationSchema={Yup.object().shape({
                            date: hasDatePicker
                                ? Yup.string().required('A data deve ser informada')
                                : Yup.string()
                        })}
                        actions={[
                            <Button
                                type='link'
                                onClick={() => {
                                    setExibirModal(false)
                                }}
                            >
                                Fechar
                            </Button>,
                            <Visibility
                                visible={isObjNotEmpty(onDownloadAllArquivos)}
                                isFragment={false}
                            >
                                <Button
                                    type='primary'
                                    onClick={onDownloadAllArquivos}
                                >Baixar Tudo
                                </Button>
                            </Visibility>,
                            <SimpleUpload // footer ATENÇÂO
                                visible={hasUpload && buttonUploadInFooter}
                                nameFormData={'arquivo'}
                                label={buttonUploadText}
                                hasFile={false}
                                type="primary"
                                idDoComponente="sgc-upload-UploadModalHistorico"
                                key="formUploadModalHistorico"
                                onUpload={(values) =>
                                    onUpload && onUpload(values)
                                        .then(() => loadArquivos())
                                }
                                onDownloadVisible={false}
                                showUploadList={false}
                                hasJustification={hasJustification}
                                labelJustification={labelJustification}
                                placeholderJustification={placeholderJustification}
                            />,
                            <Visibility
                                visible={isObjNotEmpty(onSubmit) || (isObjNotEmpty(showUploadList) && showUploadList == true)}
                                isFragment={false}
                            >
                                <FormSubmitButton noIcon type="primary">
                                    {buttonModalFooterText}
                                </FormSubmitButton>
                            </Visibility>
                        ]}
                    >
                        <FormContext.Consumer>
                            {({ formProps }) =>
                            (<>
                                <Visibility
                                    visible={hasDatePicker}
                                >
                                    <FormDatePicker
                                        format="DD/MM/YYYY"
                                        label={labelDatePicker}
                                        name="date"
                                        span={3} />
                                </Visibility>

                                <SimpleUpload
                                    visible={hasUpload && !buttonUploadInFooter}
                                    nameFormData={'arquivo'}
                                    label={buttonUploadText}
                                    hasFile={false}
                                    type="primary"
                                    idDoComponente="sgc-upload-UploadModalHistorico"
                                    key="formUploadModalHistorico"
                                    onUpload={(values) => {
                                        if (isObjNotEmpty(showUploadList) && showUploadList == true) {
                                            setTmpFileUpload(values);
                                        } else {
                                            if (onUpload && formProps) {
                                                formProps.setErrors({})
                                                if (hasJustification) {
                                                    const jus: string = formProps.values.justificativa
                                                    if (!jus) {
                                                        formProps.setErrors({ justificativa: 'O campo ' + labelJustification + ' é obrigatório.' });
                                                    } else if (jus.replace(" ", "") === "") {
                                                        formProps.setErrors({ justificativa: 'O campo ' + labelJustification + ' é obrigatório.' });
                                                    } else {
                                                        onUpload(values)
                                                            .then(() => {
                                                                formProps.setErrors({})
                                                                formProps.setFieldValue('justificativa', undefined)
                                                                loadArquivos()
                                                            });
                                                    }
                                                } else {
                                                    onUpload(values)
                                                        .then(() => loadArquivos());
                                                }
                                            }
                                        }
                                    }}
                                    onDownloadVisible={false}
                                    showUploadList={isObjNotEmpty(showUploadList)}
                                    hasJustification={hasJustification}
                                    labelJustification={labelJustification}
                                    placeholderJustification={placeholderJustification}
                                />

                                <Visibility
                                    visible={isObjNotEmpty(onGetArquivos)}
                                >
                                    <Table
                                        dataSource={arquivos}
                                        columns={columns()}
                                        rowKey="id"
                                        pagination={arquivos.length > 10 ? { pageSize: 10 } : false}
                                    />
                                </Visibility>
                            </>
                            )}
                        </FormContext.Consumer>
                    </MasterDetailForm>
                </Modal>
            </Visibility>
        </Visibility>
    )
}